// extracted by mini-css-extract-plugin
export default {"wrapper":"textbook-header_wrapper__KJAiU"};